<template>
  <landing-page></landing-page>
</template>

<script>
import LandingPage from "./pages/LandingPage.vue";

export default {
  name: "App",
  components: {
    LandingPage,
  },
};
</script>

<style lang="scss">
@font-face {
  font-family: "Play";
  src: local("Play"), url("./assets/fonts/Play-Regular.ttf") format("truetype");
  font-weight: normal;
  font-display: swap;
}

@font-face {
  font-family: "Play";
  src: local("Play-Bold"),
    url("./assets/fonts/Play-Bold.ttf") format("truetype");
  font-weight: bold;
  font-display: swap;
}

body,
html {
  background: $background1;
  background-image: url("assets/images/background3.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  color: $white;
  font-family: Play, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  margin: 0px;
  padding: 0px;
  overflow-x: hidden;
  width: 100%;
  @include respond("desktop-sm") {
    background-position: left bottom;
  }
}

h1 {
  font-family: Play, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 60px;
  margin: 0px 0px 20px 0px;
  padding: 0px;
}

h2 {
  @extend h1;
  font-size: 25px;
  margin: 0px 0px 20px 0px;
}
</style>
